/**
 * Builds an iSite column link URL, shared by annual (LinkRow) and quarterly (RollingRow) LINK rows.
 *
 * Mirrors the annual link exactly: appends `&COCODE=<statementTypeCode><cocode>` and
 * `&DATA_YEAR=<dataYear>` to the row's base `linkURL`.
 *
 * For quarterly columns, pass the column's 1-based `quarter` so the report number in the base URL
 * is replaced with that column's quarter (`REPORT=03` → `REPORT=02`/`01`/…). Annual callers omit
 * `quarter`, leaving the base `REPORT` untouched — so annual output is unchanged.
 *
 * @param baseUrl the row's configured linkURL (e.g. "/scoring/ScoMasterServlet?REPORT=03&CATEGORY=SCORING")
 * @param statementTypeCode statement type letter used as the COCODE prefix (e.g. "P", "X", "L")
 * @param cocode company code
 * @param dataYear the column's data year (DATA_YEAR)
 * @param quarter optional 1-based quarter (1..4); when provided, substitutes REPORT=0N
 */
export function buildScoringColumnUrl(
  baseUrl: string,
  statementTypeCode: string,
  cocode: string | number,
  dataYear: string | number,
  quarter?: number
): string {
  let url = baseUrl;
  if (quarter != null) {
    url = url.replace(/REPORT=\d+/i, `REPORT=${String(quarter).padStart(2, '0')}`);
  }
  return `${url}&COCODE=${statementTypeCode}${cocode}&DATA_YEAR=${dataYear}`;
}
